import s from "./Spinner.module.css";

export interface SpinnerProps {
  /** Diameter in px. */
  size?: number;
  className?: string;
}

/**
 * Purely decorative — the loading state it reflects (e.g. a disabled
 * button) is already conveyed to assistive tech some other way, so this
 * never gets its own accessible name.
 */
export function Spinner({ size = 16, className }: SpinnerProps) {
  const classes = className ? `${s.root} ${className}` : s.root;
  return <span className={classes} style={{ width: size, height: size }} aria-hidden="true" />;
}
